import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import DeleteIcon from '@mui/icons-material/DeleteOutlined'
import EditIcon from '@mui/icons-material/Edit'

import { routePaths, getRoute, userRightTypes } from '../../../../constants'
// import { Logger, LoggerTypes } from '../../../../utils'
import { searchScenarios } from '../../../../actions'
import { PageTitle, DataGrid, ButtonIcon, DataGridRowLink } from '../../../../components'
import { ScenarioDialogUpdate, ScenarioDialogDelete } from '../../dialogs'
import { checkPermissions } from '../../../../components/AccessControl'

export const ScenarioArchivedList = ({ pid, isLoading, archived }) => {
  const [searchValue, setSearchValue] = useState('')

  const { t } = useTranslation()

  const onSearch = (txt) => {
    setSearchValue(txt)
    useDispatch(searchScenarios(txt))
  }

  const COLUMN_HEADER = [
    { field: 'id', hide: true },
    {
      field: 'name',
      type: 'string',
      headerName: t('scenarios.table.columns.name'),
      flex: 1,
      cellClassName: 'projectNameCell',
      renderCell: (e) => (
        <DataGridRowLink
          href={getRoute(routePaths.SCENARIO_FLOW_GROUPS, { pid, sid: e.row.id })}
          text={e.formattedValue}
          tooltip={e.row.description}
        />
      )
    },
    {
      field: 'phase',
      type: 'string',
      headerName: t('scenarios.table.columns.phase'),
      width: 120
      // renderCell: e => <DataGridRowRounded>{e.formattedValue}</DataGridRowRounded>,
    },
    {
      field: 'status',
      type: 'string',
      headerName: t('scenarios.table.columns.status'),
      editable: false,
      width: 90
    },
    {
      field: 'flow_count',
      type: 'number',
      headerName: t('scenarios.table.columns.flows'),
      editable: false,
      width: 90
    },
    {
      field: 'simulation_count',
      type: 'number',
      headerName: t('scenarios.table.columns.simulations'),
      editable: false,
      width: 120
    },
    {
      field: 'update_user',
      type: 'string',
      headerName: t('scenarios.table.columns.author'),
      editable: false,
      width: 100
    },
    {
      field: 'creation_date',
      type: 'string',
      headerName: t('scenarios.table.columns.creation_date'),
      editable: false,
      width: 100
    },
    {
      field: 'last_update_date',
      type: 'string',
      headerName: t('scenarios.table.columns.last_update'),
      editable: false,
      width: 100
    }

    // {
    //   field: 'Simulations',
    //   type: 'string',
    //   headerName: t('scenarios.table.columns.simulations'),
    //   width: 400,
    // },
    // {
    //   field: 'Keywords',
    //   type: 'string',
    //   headerName: t('scenarios.table.columns.keywords'),
    //   width: 400,
    // },
  ]

  // Logger.trace(LoggerTypes.CONTAINER, 'ScenarioArchivedList.render()', { archived })

  return (
    <div className="content_scene__center__body table">
      <PageTitle title={t('scenarios.table.types.archived')} />
      <DataGrid
        actionsButtons={[
          <ButtonIcon
            disabled={!checkPermissions([userRightTypes.SCENARIO_EDIT])}
            key={'button-edit'}
            DialogClass={ScenarioDialogUpdate}
            icon={<EditIcon />}
            tooltip={t('common.update')}
          />,
          <ButtonIcon
            disabled={!checkPermissions([userRightTypes.SCENARIO_DELETE])}
            key={'button-delete'}
            DialogClass={ScenarioDialogDelete}
            icon={<DeleteIcon />}
            tooltip={t('common.delete')}
          />
        ]}
        columns={COLUMN_HEADER}
        rows={archived}
        isLoading={isLoading}
        searchValue={searchValue}
        onSearch={onSearch}
      />
    </div>
  )
}

ScenarioArchivedList.displayName = 'ScenarioArchivedList'

ScenarioArchivedList.propTypes = {
  pid: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  archived: PropTypes.array.isRequired
}

ScenarioArchivedList.defaultProps = {
  pid: '',
  isLoading: true,
  archived: []
}
